import { NavLink } from "react-router";
import type { Fond } from "../../types/Fond";

function AppelsListItem({fond}:{fond:Fond}){
    console.log(fond);
    return (
        <div>
            <h3>{fond.titre}</h3>
            {fond.vignette ?
            <img src={fond.vignette.filename} alt="vignette" /> :null}
            <NavLink to={`/appels/${fond.id.toString()}`}>xx</NavLink>
        </div>
    )
}
export default AppelsListItem;